import { formatDate } from '@/util/dateUtils';

type DateInput = string | Date | number;

const DEFAULT_DATE_FORMAT = 'MMM dd, yyyy';

/**
 * True when start and end fall on the same calendar day in the user's timezone.
 *
 * Compares via formatDate so date-only strings ("2026-06-09") are parsed as
 * local midnight — the same way the toolbar date chip parses them. Raw
 * `new Date("2026-06-09")` would parse as UTC midnight and drift a day in
 * negative-UTC-offset timezones.
 */
export const isSingleDayRange = (start: DateInput, end: DateInput): boolean =>
  formatDate(start, 'yyyy-MM-dd') === formatDate(end, 'yyyy-MM-dd');

/**
 * Period label for analytics card subtitles, e.g. "Jun 09, 2026" for a single
 * day or "Jun 09, 2026 - Jun 15, 2026" for a range.
 *
 * Routes through formatDate so the label matches the DateFilter chip exactly
 * and never drifts a day across timezones.
 */
export const formatDateRangeLabel = (
  start: DateInput,
  end: DateInput,
  dateFormat: string = DEFAULT_DATE_FORMAT
): string =>
  isSingleDayRange(start, end)
    ? formatDate(start, dateFormat)
    : `${formatDate(start, dateFormat)} - ${formatDate(end, dateFormat)}`;
